import React  , { Component } from 'react'

import {  HomeSlider,
          HomeTitle,
          Img,
          CoverSection,
          ResponsiveYouTubeIframe       } from '../../Components/UI/UI'

import { getWeather, asyncgetWeather,
  isMobile } from "../../Utility/Utility";

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "./CoronaVirus.css"

class CoronaVirus extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}
  
  render(){
    return(
      <div className="page align-left page-Corona-virus">
        <Menu />
         {/* <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />*/}
         {!isMobile() ? (
          <CoverSection
            desktopImg={'/HomeSlider/desktop/uk/1a.jpg'}
            mobileImg={'/HomeSlider/M/uk/4.jpg'}
            cssClass={'north'}
            waterTemp={this.state.waterTemp}
            telAvivWeather={this.state.telAvivWeather}
            jerusalemWeather={this.state.jerusalemWeather}
          />
        ) : (
          <div className="ac-corona-mobile-video">
            <ResponsiveYouTubeIframe vidId={'yE5MV_10cZw'} />
          </div>
        )}
            
          <div className="container">
             
             <div className="ac-new-container">
             <div className="ac-new-container">
 <h2 className="ac-pink"></h2>

 <h2 className="ac-pink ac-pink ac-margin-top-1 ac-bigger">مرحبًا بعودتكم</h2>
 <h2><span><strong>السفر إلى إسرائيل بالنسبة للرعايا الأجانب الملقّحين بالكامل</strong></span></h2><br/>
اعتبارًا من 1 تشرين الثاني/نوفمبر 2021، سيُسمَح للأجانب المؤهلين الملقّحين بالكامل بدخول إسرائيل وفقًا للأحكام والشروط التالية:
 <ul>
    <li>1. لم تكن موجودًا في بلد من بلاد القائمة الحمراء في أثناء 14 يومًا قبل دخول إسرائيل.</li>
    <li>2. حصلت على أحد اللقاحات المعتمدة من منظمة الصحّة العالمية، ووفقًا للشروط الموضحة أدناه.</li>
    <li>3. الدخول إلى إسرائيل عبر مطار بن غوريون فقط.</li>
    <li>4. لا توجد موانع أخرى تحول دون دخولك إلى إسرائيل.</li>
    <li>5. يجوز للرعايا الأجانب الذين لا يستوفون الشروط السابقة الدخول إلى إسرائيل، وذلك من خلال <a href="https://survey.gov.il/he/PCR2" target="_blank" rel="noopener">لجنة الحالات الاستثنائية</a></li>
 </ul>
 <h2 className="ac-pink">اللقاحات المعترف بها</h2><br/>
 <p className="ac-align-left-15">تعتمد إسرائيل اللقاحات التالية: مودرنا، فايزر، جونسون آند جونسون – يانسن، أسترازينيكا، كوفيشيلد، سينوفارم، سينوفاك، سبوتنيك-في (وفقًا للشروط والأحكام أدناه)</p>
 <br/>
 <p className="ac-align-left-15"><strong>من الذين تعتبرهم إسرائيل ملقّحين بالكامل؟</strong></p>
 
 <p className="ac-align-left-15">الرعايا الأجانب الملقّحين بلقاح فايزر / مودرنا / أسترازينيكا / سينوفاك أو سينوفارم:</p>
 <ul>
    <li>● إذا كنت قد أكملت جرعتين من اللقاح، فعند دخولك إلى إسرائيل، يجب أن تكون قد مرت مدة لا تقل عن 14 يومًا منذ تلقيك جرعة اللقاح الثانية (ولكن يجب ألا تزيد عن 180 يومًا بحلول موعد رحيلك عن إسرائيل).</li>
    <li>● إذا كنت قد تلقيت جرعة معززة، فعند دخولك إلى إسرائيل، يجب أن تكون قد مرت مدة لا تقل عن 14 يومًا منذ تلقيك الجرعة المعززة.</li>
 </ul>
 &nbsp;
 
 <p className="ac-align-left-15">الرعايا الأجانب الملقّحين بلقاح جونسون آند جونسون – يانسن:</p>
 <ul>
    <li>● يجب أن تمر مدة لا تقل عن 14 يومًا منذ تاريخ تلقي اللقاح (ولكن يجب ألا تزيد عن 180 يومًا بحلول موعد رحيلك عن إسرائيل).</li>
    <li>● إذا كنت قد تلقيت جرعة معززة، فعند دخولك إلى إسرائيل، يجب أن تكون قد مرت مدة لا تقل عن 14 يومًا منذ تلقيك الجرعة المعززة.</li>
 </ul>
 &nbsp;
 
 <p className="ac-align-left-15">الرعايا الأجانب الملقّحين بلقاح سبوتنيك:</p>
 <ul>
    <li>● الرعايا الأجانب الملقّحين بلقاح سبوتنيك، اعتبارًا من 15/11/2021، والذين كانت نتيجتهم إيجابية في الاختبار المصلي للأجسام المضادة لـ COVID والذي يجرى في إسرائيل (يجب أن تظل في العزل حتى ظهور نتيجة إيجابية).</li>
    <li>● يجب أن تكون قد أكملت جرعتين من اللقاح، وعند الدخول إلى إسرائيل، يجب أن تكون قد مرت مدة لا تقل عن 14 يومًا منذ تلقيك جرعة اللقاح الثانية (ولكن يجب ألا تزيد عن 180 يومًا بحلول موعد رحيلك عن إسرائيل).</li>
    <li>● إذا كنت قد تلقيت جرعة معززة، فعند دخولك إلى إسرائيل، يجب أن تكون قد مرت مدة لا تقل عن 14 يومًا منذ تلقيك الجرعة المعززة.</li>
 </ul>
 <h2><strong>الدخول إلى إسرائيل بالنسبة للأفراد الذين تعافوا تمامًا من الإصابة بـ COVID</strong></h2><br/>
 <p className="ac-align-left-15">سيُسمَح للرعايا الأجانب الذين تعافوا من COVID بدخول إسرائيل إذا كان لديهم شهادة رقمية يمكن لأنظمة وزارة الصحة الإسرائيلية التحقق من صحتها  وتستند إلى نتيجة إيجابية لاختبار NAAT (اختبار جزيئي مشابه لـ PCR).</p>
 <ul>
    <li>● عند الدخول إلى إسرائيل، يجب أن تمر مدة لا تقل عن 11 يومًا منذ الحصول على نتيجة إيجابية للاختبار (ولكن يجب ألا تزيد عن 190 يومًا بحلول موعد الرحيل عن إسرائيل). </li>
    <li>● يجب أن تكون قد تلقيت جرعة واحدة على الأقل من أحد اللقاحات المعتمدة من منظمة الصحة العالمية (يمكن أن تؤخذ قبل الإصابة أو بعدها). </li>
 </ul>
 <a href="#_ednref1" name="_edn1"></a>
 
 
 <h2><strong>عملية الدخول إلى إسرائيل</strong></h2>
 <br/>
 <ul className="ac-wrpr-num">
    <li className="ac-num-li">1. يجب أن تجري اختبار PCR قبل رحلتك بـ 72 ساعة بحد أقصى</li>
    <li className="ac-num-li">2. يجب عليك إكمال <a href="https://corona.health.gov.il/ar/directives/air-travel-covid19-israel/" target="_blank" rel="noopener">إقرار المسافر </a>قبل دخول إسرائيل.
        <ul>
            <li>● يجب على المسافرين الذين يحملون شهادة رقمية يمكن التحقق منها مسح أو تحميل شهادة التلقيح أو التعافي في استمارة المسافر القادم وسيحصلون على تصريح دخول قبل الصعود على متن الطائرة.</li>
            <li>● على المسافرين الذين ليس لديهم شهادة رقمية يمكن التحقق منها أن يصرحوا بحالة حصولهم على التلقيح في استمارة المسافر القادم وأن يتقدموا بطلب لتقصير فترة العزل. بعد ذلك، يرفقوا الوثائق ذات الصلة للحصول على تصريح دخول قبل الصعود على متن الطائرة.</li>
        </ul>
    </li>
    <li className="ac-num-li">3. عند الصعود على متن الطائرة، يجب تقديم الوثائق التالية
      <ul>
          <li>● وثائق تثبت الحصول على نتيجة سلبية لاختبار PCR قبل الرحلة بـ 72 ساعة بحد أقصى.</li>
          <li>● تأكيد إرسال إقرار المسافر القادم.</li>
          <li>● شهادة التلقيح التي تثبت أداء اللقاحات وفقاً للأحكام الموضحة أعلاه.</li>
          <li>● شهادة التعافي، يمكن لأنظمة وزارة الصحة الإسرائيلية التحقق من صحتها رقمياً، وتشير إلى التعافي وفقًا للأحكام المنصوص عليها الواردة أعلاه.</li>
          <li>● شهادة رقمية تشهد على التعافي من COVID وفقًا للأحكام الواردة أعلاه.</li>
          <li>● تصريح دخول استثنائي من وزارة الداخلية الإسرائيلية (الحالات الاستثنائية، الموجز، المجموعات)</li>
      </ul>
   </li>
    <li className="ac-num-li">4. ستجرى سلطة السكان فحوص عشوائية للتأكد من استيفاء الوثائق للشروط في مطار بن غوريون.</li>
    <li className="ac-num-li">5. يجب إجراء اختبار PCR عند الهبوط في مطار بن غوريون. يجب عليك الدخول في العزل إلى حين الحصول على نتيجة سلبية، أو لمدة 24 ساعة، أيهما أسبق.</li>
    <li className="ac-num-li">6. يجب على المسافرين الحاصلين على لقاح سبوتنيك الخضوع لإجراء اختبار مصلي في مطار بن غوريون والدخول في العزل إلى حين الحصول على نتيجة اختبار إيجابية (إلى جانب العزل إلى حين الحصول على نتيجة سلبية لاختبار PCR الذي يجرى عند الهبوط).</li>
 </ul>
 <br/>
 <p className="ac-align-center">للاطلاع على قائمة البلاد التي تُصدِر شهادات يمكن لأنظمة وزارة الصحة الإسرائيلية التحقق من صحتها رقميًا:<br/>
 <a href="https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en" target="_blank" rel="noopener" className="ac-align-center">https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en</a></p><br/>
 <p  className="ac-align-center">للاطلاع على تفاصيل بروتوكول الدخول بالكامل، انقر هنا:<br/>
 <a href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"  className="ac-align-left-15" target="_blank" rel="noopener">https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air</a></p><br/>
 <p  className="ac-align-center"><strong><span>ترد هنا تفاصيل المبادئ التوجيهية المذكورة أعلاه للعلم وتيسير الرجوع إليها. عند الشك، يرجى الرجوع إلى المبادئ التوجيهية المنشورة على الموقع الإلكتروني لوزارة الصحة الإسرائيلية، إذ يحتوي ذلك الموقع على أحدث وأدق المعلومات.</span>
 </strong><br/> <a href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"  className="ac-align-center" target="_blank" rel="noopener">https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air</a></p>
 
 <h2 className="ac-pink">نراكم قريبًا</h2>
 </div>
 
  <div className="ac-inner-video">
    <ResponsiveYouTubeIframe vidId={'LSb4Lmuw_Kw'}/>
  </div>
 </div>
 
           </div>
 
 
           
         <Footer />
       </div>
 
    )
    }

}



export default CoronaVirus


// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirus.js